import { render, staticRenderFns } from "./CameraPageShootCardFrontBack.vue?vue&type=template&id=50f30642&scoped=true&"
import script from "./CameraPageShootCardFrontBack.vue?vue&type=script&lang=ts&"
export * from "./CameraPageShootCardFrontBack.vue?vue&type=script&lang=ts&"
import style0 from "./CameraPageShootCardFrontBack.vue?vue&type=style&index=0&id=50f30642&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f30642",
  null
  
)

export default component.exports